import { Form, Input } from "antd";
import { DATE_FORMAT } from "common/constants";
import moment from "moment-timezone";
import styled from "styled-components";

const StyledValue = styled.span`
  flex: 1;
  overflow-wrap: anywhere;
`;

const StyledLabel = styled.span`
  text-transform: capitalize;
  color: grey;
  font-size: 12px;
  flex: 1;
`;

const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledFormItem = styled(Form.Item)`
  .ant-form-item-row {
    align-items: center;
  }
  .ant-form-item-label {
    white-space: pre-wrap;
    word-break: break-all;
  }
}
`;

const formatDate = (value) => {
  // If the value is a date, format it
  const date = moment(value);
  return date.isValid() ? date.format(DATE_FORMAT) : value;
};

export default function DisplayComponent(props) {
  const {
    isEditing,
    label,
    name,
    slice,
    children,
    placeholder,
    maxLength,
    isDate,
    outputFormatter,
    readOnly,
    showFalsyValues,
  } = props;

  // Cleanup props
  const { isEditing: _, showFalsyValues: __, ...eligibleProps } = props;

  if (isEditing && !readOnly) {
    return (
      <StyledFormItem colon={false} {...eligibleProps}>
        {children ?? <Input placeholder={placeholder} maxLength={maxLength} />}
      </StyledFormItem>
    );
  }

  const hasValue = showFalsyValues ? slice?.[name] !== undefined : slice?.[name];
  if (hasValue && !isEditing) {
    const value = outputFormatter ? outputFormatter(slice[name]) : slice[name];
    return (
      <StyledContainer>
        <StyledLabel>{label}</StyledLabel>
        <StyledValue>{isDate ? formatDate(value) : value}</StyledValue>
      </StyledContainer>
    );
  }

  if (slice?.[name[0]]?.[name[1]] !== undefined && !isEditing) {
    const value = outputFormatter
      ? outputFormatter(slice[name[0]][name[1]])
      : slice[name[0]][name[1]];
    return (
      <StyledContainer>
        <StyledLabel>{label}</StyledLabel>
        <StyledValue>{isDate ? formatDate(value) : value}</StyledValue>
      </StyledContainer>
    );
  }

  return null;
}
